// extracted by mini-css-extract-plugin
export default {"outlet":"home_outlet__wSgty","title":"home_title__L-qc9","home":"home_home__Jsjxk","link":"home_link__8Zeua"};